import Model, { attr } from '@ember-data/model';

export default class AmenityModel extends Model {
  @attr('string') name!: string;
  @attr('string') group!: string;
}

declare module 'ember-data/types/registries/model' {
  interface ModelRegistry {
    amenity: AmenityModel;
  }
}
